import React from "react";
import { makeStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import { Typography, Box } from "@mui/material";

const ITabs = (props) => {
  // props
  const { children, width, title, style, ...attribute } = props;
  // Styled
  const useStyles = makeStyles((theme) => ({
    container: {
      width,
      borderRight: "1px solid #e5e7eb",
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100vh - 170px)",
      backgroundColor: "#ffffff",
    },
    header: {
      padding: "16px 20px 12px 20px",
      borderBottom: "1px solid #e5e7eb",
      flexShrink: 0,
    },
    headerTitle: {
      fontSize: "12px",
      fontWeight: 600,
      color: "#6b7280",
      letterSpacing: "0.5px",
      textTransform: "uppercase",
    },
    tabs: {
      flex: 1,
      overflowY: "auto",
      padding: "2px 10px",
      "& .MuiTabs-indicator": {
        display: "none",
      },
      "& .MuiTabs-flexContainer": {
        gap: "4px",
      },
    },
  }));
  // classes
  const classes = useStyles();
  // Render
  return (
    <div className={classes.container}>
      <Box className={classes.header}>
        <Typography className={classes.headerTitle}>{title}</Typography>
      </Box>
      <Tabs
        variant="scrollable"
        aria-label="Vertical"
        className={classes.tabs}
        {...attribute}
      >
        {children}
      </Tabs>
    </div>
  );
};

ITabs.defaultProps = {
  orientation: "vertical",
};

export default ITabs;
